import { createRouter, createWebHistory } from "vue-router";

import Cookies from "js-cookie";



/* 编写路由 */
const routes = [
  {
    path: "/",
    component: () => import("@/views/homePage/homePage.vue")
  },
  {
    path: "/loginPage",
    component: () => import("@/views/LoginPage/index.vue")
  },
  {
    path: "/homePage",
    component: () => import("@/views/homePage/homePage.vue")
  },
  {
    path: "/examPage",
    component: () => import("@/views/examPage/examPage.vue")
  },
  {
    path: "/:kslx/teacherPage/:id?",
    component: () => import("@/views/teacherPage/teacherPage.vue")
  },
  {
    path: "/teacherPage/:id?",
    component: () => import("@/views/teacherPage/teacherPage.vue")
  },
  {
    path: "/showPage",
    component: () => import("@/views/showPage/showPage.vue")
  },
  {
    path: "/listPage",
    component: () => import("@/views/listPage/listPage.vue")
  },
  {
    path: "/:kslx/list/:categories/:secondName",
    component: () => import("@/views/listPage/listPage.vue")
  },
  {
    path: "/:kslx/list/:categories",
    component: () => import("@/views/listPage/listPage.vue")
  },
  {
    path: "/buildPage",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx/build",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx/build/:categories/:secondName",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx/build/:categories",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    isMobile: true,
    path: "/homePageMobile",
    component: () => import("@/views/homePageMobile/homePageMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/secondBuilder",
    component: () => import("@/views/secondBuilder/secondBuilder.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilder/:categories/:secondName",
    component: () => import("@/views/secondBuilder/secondBuilder.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilder/:categories",
    component: () => import("@/views/secondBuilder/secondBuilder.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilder",
    component: () => import("@/views/secondBuilder/secondBuilder.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/secondBuilderHome",
    component: () => import("@/views/secondBuilderHome/secondBuilderHome.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilderHome/:secondName",
    component: () => import("@/views/secondBuilderHome/secondBuilderHome.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilderHome",
    component: () => import("@/views/secondBuilderHome/secondBuilderHome.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/secondBuilderSignUp",
    component: () => import("@/views/secondBuilderSignUp/secondBuilderSignUp.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/secondBuilderDetail",
    component: () => import("@/views/secondBuilderDetail/secondBuilderDetail.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/secondBuilderDetail/:article",
    component: () => import("@/views/secondBuilderDetail/secondBuilderDetail.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/teacherPageMobile",
    component: () => import("@/views/teacherPageMobile/teacherPageMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/examPageMobile",
    component: () => import("@/views/examPageMobile/examPageMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/teacherPageMobile/:id?",
    component: () => import("@/views/teacherPageMobile/teacherPageMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    path: "/teacherList",
    component: () => import("@/views/teacherList/teacherList.vue")
  },
  {
    path: "/:kslx/teacherList",
    component: () => import("@/views/teacherList/teacherList.vue")
  },
  {
    isMobile: true,
    path: "/teacherListMobile",
    component: () => import("@/views/teacherListMobile/teacherListMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    isMobile: true,
    path: "/:kslx/teacherListMobile",
    component: () => import("@/views/teacherListMobile/teacherListMobile.vue"),
    meta: {
      isMobile: true,
    }
  },
  {

    path: "/modulePageMobile",
    component: () => import("@/views/modulePage/modulePage.vue"),
    meta: {
      isMobile: true,
    }
  },
  {
    path: "/:kslx/show/:article",
    component: () => import("@/views/showPage/showPage.vue")
  },
  {
    path: "/:kslx/show/:article.html",
    component: () => import("@/views/showPage/showPage.vue")
  },
  {
    path: "/:kslx/list",
    component: () => import("@/views/listPage/listPage.vue")
  },
  {
    path: "/:kslx/build/:categories/:secondName",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx/build/:categories",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx/build",
    component: () => import("@/views/buildPage/buildPage.vue")
  },
  {
    path: "/:kslx",
    component: () => import("@/views/examPage/examPage.vue")
  },
];

let router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 每次路由跳转时都滚动到页面顶部
    return { top: 0 }
  },
});

router.beforeEach((to, from, next) => {
  if (document.documentElement.clientWidth < 900) {

    if (to?.meta?.isMobile) {
      next()
    }
    else {
      next("/homePageMobile")
    }
  }
  else {
    if (!to?.meta?.isMobile) {
      next()
    }
    else {
      next("/homePage")
    }
  }
})

export default router;